module.exports = __webpack_public_path__ + "img/TC.61423c3d.svg";